import React from "react";
import { IconType } from "./types";

export function MagnifingGlassIcon({ color = "#6A6A6A", scale = 1 }: IconType) {
  return (
    <svg
      width={scale * 10}
      height={scale * 10}
      viewBox="0 0 10 10"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.08391 8.09048C4.97079 8.09048 5.78864 7.80642 6.45778 7.33298L8.97504 9.82641C9.09188 9.94214 9.24588 10 9.41052 10C9.75571 10 10 9.73698 10 9.40032C10 9.2425 9.94689 9.08995 9.83006 8.97948L7.32873 6.49658C7.85449 5.81273 8.16782 4.96581 8.16782 4.04524C8.16782 1.82009 6.33032 0 4.08391 0C1.8428 0 0 1.81483 0 4.04524C0 6.27038 1.83749 8.09048 4.08391 8.09048ZM4.08391 7.21725C2.33139 7.21725 0.881572 5.78117 0.881572 4.04524C0.881572 2.30931 2.33139 0.873225 4.08391 0.873225C5.83643 0.873225 7.28625 2.30931 7.28625 4.04524C7.28625 5.78117 5.83643 7.21725 4.08391 7.21725Z"
        fill="inherit"
        fillOpacity="inherit"
      />
    </svg>
  );
}
